import { render, staticRenderFns } from "./OrgAdminSettings.vue?vue&type=template&id=319a2bd8&"
import script from "./OrgAdminSettings.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports